import { useMemo } from 'react';
import { BREAKPOINTS_IN_PIXELS, BREAKPOINTS_LABELS } from '@/constants/gui';

type MediaQueryFunc = (query: string, defaultValue?: boolean) => boolean;

export const useScreenSize = (mediaQueryFunc: MediaQueryFunc, isMobileDevice = false) => {
  const isLargeDesktop = mediaQueryFunc(BREAKPOINTS_IN_PIXELS.minWidth.xl, !isMobileDevice);
  const isDesktop = mediaQueryFunc(BREAKPOINTS_IN_PIXELS.minWidth.lg, !isMobileDevice);
  const isTablet = mediaQueryFunc(BREAKPOINTS_IN_PIXELS.minWidth.md, !isMobileDevice);
  const isMobileOrTablet = mediaQueryFunc(BREAKPOINTS_IN_PIXELS.maxWidth.lg, isMobileDevice);
  const isMobile = mediaQueryFunc(BREAKPOINTS_IN_PIXELS.maxWidth.md, isMobileDevice);
  const isLittleMobile = mediaQueryFunc(BREAKPOINTS_IN_PIXELS.maxWidth.sm, isMobileDevice);

  const mappedBreakpoint = useMemo(() => {
    if (isLargeDesktop) return BREAKPOINTS_LABELS[5];
    if (isDesktop) return BREAKPOINTS_LABELS[4];
    if (isTablet) return BREAKPOINTS_LABELS[3];
    if (isMobileOrTablet) return BREAKPOINTS_LABELS[2];
    if (isMobile) return BREAKPOINTS_LABELS[1];
    if (isLittleMobile) return BREAKPOINTS_LABELS[0];
    return BREAKPOINTS_LABELS[0];
  }, [isLargeDesktop, isDesktop, isTablet, isMobileOrTablet, isMobile, isLittleMobile]);

  return { isLargeDesktop, isDesktop, isMobileOrTablet, isTablet, isMobile, isLittleMobile, mappedBreakpoint };
};
